'use client'

import { useEffect } from 'react'

import { clientLogger } from '@repo/observability/client'

import { useUser } from '@/contexts/user/UserContext'

/**
 * Forwards the therapist app's UserContext into the observability
 * singleton so every client-side error row carries userId + proId +
 * userRole. Mounted once in the root layout right below UserProvider.
 *
 * Role derivation matches the app's semantic hierarchy: admin trumps
 * senior-supervisor trumps supervisor trumps therapist. This is what
 * the admin viewer filters by when scoping errors to a role.
 */
export function ObservabilityUserSync() {
  const { profile } = useUser()

  useEffect(() => {
    if (!profile) return
    const role =
      profile.isAdmin ? 'admin'
      : profile.isSeniorSupervisor ? 'senior-supervisor'
      : profile.isSupervisor ? 'supervisor'
      : profile.isTherapist ? 'therapist'
      : 'user'
    clientLogger.setUser({
      userId: profile.authId,
      proId: profile.id,
      userRole: role,
    })
  }, [profile])

  return null
}
